import { MouseEvent, useCallback } from 'react';
import { Button, ButtonProps, attempt } from 'yoso';
import { useDropdown } from '~/components/Dropdown/Dropdown.hooks';

export type DropdownButtonProps = ButtonProps;

export const DropdownButton = ({ onClick, children, ...props }: DropdownButtonProps) => {
  const context = useDropdown();
  const { active, open, close } = context;

  const handleClick = useCallback(
    (event: MouseEvent) => {
      active ? close() : open();
      onClick?.(event);
    },
    [active, close, onClick, open]
  );

  return (
    <Button onClick={handleClick} {...props}>
      {attempt(children, context)}
    </Button>
  );
};
